/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./accountMgmtSettings.vue?vue&type=template&id=cf843314&scoped=true"
import script from "./accountMgmtSettings.vue?vue&type=script&lang=js"
export * from "./accountMgmtSettings.vue?vue&type=script&lang=js"
import style0 from "./accountMgmtSettings.vue?vue&type=style&index=0&id=cf843314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf843314",
  null
  
)

export default component.exports